import App from './app';
import { Page, MultiPage } from './page';
import { on, off } from './error_catch';

export { App, Page, MultiPage, on, off };